import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("courierTestimonals", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("courierTestimonals")
      ) {
        return {
          type: "courierTestimonals",
        };
      }
    },
    model: {
      defaults: {
        tagName: "div",
        classes: ["courierTestimonals"],
        traits: [
          {
            type: "checkbox",
            label: "Autoplay",
            name: "autoplay",
            valueTrue: "YES",
            valueFalse: "NO",
          },
        ],
        components: /*html*/ `
        <section class="w-full mt-4" style="background-image: url('https://icons.s3.ap-south-1.amazonaws.com/close-up-courier-holding-cardboard-boxes-with-parcels-inside-for-delivery-ai-generated-photo.jpg'); background-size: cover; background-position: center;">
        <div class='bg-[#00000080] py-12' >
        <div class='flex justify-center'>
          <h2 class='font-bold text-3xl text-white my-4'>TESTIMONIALS</h2>
        </div>
          <div class="swiper MySwiper text-white ">
            <div class="swiper-wrapper mb-10 ">
              <div class="swiper-slide  ">
                <div class='w-full flex justify-center items-center flex-col gap-y-6'>
                  <img src="https://via.placeholder.com/100"  alt='Testimonial' class="w-20 h-20" />
                  <div class='max-w-[600px]'>
                    <p>We have been using the pick and drop service of Danfe Express for our Bluebook business, and we are happy with the service. Their service is reliable & punctual. The convenience and efficiency they offer have significantly improved our operations. We recommend Danfe Express to anyone in need of a dependable courier service.</p>
                  </div>
                  <div class='text-sm'>
                    <h2 class='font-bold'>Danfe</h2>
                  </div>
                </div>
              </div>
              <div class="swiper-slide   ">
                <div class='w-full flex justify-center items-center flex-col gap-y-6'>
                  <img src="https://via.placeholder.com/100"  alt='Testimonial' class="w-20 h-20" />
                  <div class='max-w-[600px]'>
                    <p>We have been using the pick and drop service of Danfe Express for our Bluebook business, and we are happy with the service. Their service is reliable & punctual. The convenience and efficiency they offer have significantly improved our operations. We recommend Danfe Express to anyone in need of a dependable courier service.</p>
                  </div>
                  <div class='text-sm'>
                    <h2 class='font-bold'>Danfe</h2>
                  </div>
                </div>
              </div>
              <div class="swiper-slide   ">
                <div class='w-full flex justify-center items-center flex-col gap-y-6'>
                  <img src="https://via.placeholder.com/100"  alt='Testimonial' class="w-20 h-20" />
                  <div class='max-w-[600px]'>
                    <p>We have been using the pick and drop service of Danfe Express for our Bluebook business, and we are happy with the service. Their service is reliable & punctual. The convenience and efficiency they offer have significantly improved our operations. We recommend Danfe Express to anyone in need of a dependable courier service.</p>
                  </div>
                  <div class='text-sm'>
                    <h2 class='font-bold'>Danfe</h2>
                  </div>
                </div>
              </div>
              <div class="swiper-slide   ">
                <div class='w-full flex justify-center items-center flex-col gap-y-6'>
                  <img src="https://via.placeholder.com/100"  alt='Testimonial' class="w-20 h-20" />
                  <div class='max-w-[600px]'>
                    <p>We have been using the pick and drop service of Danfe Express for our Bluebook business, and we are happy with the service. Their service is reliable & punctual. The convenience and efficiency they offer have significantly improved our operations. We recommend Danfe Express to anyone in need of a dependable courier service.</p>
                  </div>
                  <div class='text-sm'>
                    <h2 class='font-bold'>Danfe</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination "></div>
          </div>
        </div>
      </section>
        `,
        script: function () {
          const autoplayEnabled = this.getAttribute("autoPlay") === "YES";
          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".MySwiper", {
              direction: "horizontal",
              slidesPerView: 1,
              centeredSlides: true,
              spaceBetween: 30,
              autoplay: autoplayEnabled
                ? {
                    delay: 2500,
                    disableOnInteraction: false,
                  }
                : false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
          };
          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
